import React from "react";
import { useQueryClient } from "react-query";
import { Button, Flex, Divider, Text, Card } from "@aws-amplify/ui-react";
import { useUserQuery } from "../common/useUserQuery";
import {
  useHRImagingAndLabsDocumentsQuery,
  IMAGING_QUERY_KEY,
  MEDIA_QUERY_KEY,
} from "./api/useImagingAndLabsQuery";
import { RiPencilFill } from "react-icons/ri";
import { FiTrash } from "react-icons/fi";
import MicroscopeComponent from "../common/MicroscopeComponent";
import { useNavigate } from "react-router-dom";
import { useImagingDeleteDocumentMutation } from "./api/useImagingAndLabsMutation";

export default function ImagingAndLabsPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: userQueryData } = useUserQuery();
  const { mutate: deleteDocumentMutate } = useImagingDeleteDocumentMutation();

  const {
    error,
    data: documentResults,
    isFetching,
  } = useHRImagingAndLabsDocumentsQuery(userQueryData?.patientUserId);

  const handleOnDocumentDeleteClick = (id) => {
    deleteDocumentMutate(id);
  };

  if (isFetching) return "Loading...";

  if (error) return "An error happened, try refreshing the browser.";

  return documentResults?.map((document) => {
    return (
      <>
        <Card key={document.id}>
          <Flex direction="row" alignItems="flex-start">
            <MicroscopeComponent />
            <Flex direction="column" alignItems="flex-start" gap={1}>
              <Button
                size="small"
                variation="link"
                onClick={() => {
                  queryClient.invalidateQueries({
                    queryKey: [IMAGING_QUERY_KEY],
                  });
                  queryClient.invalidateQueries({
                    queryKey: [MEDIA_QUERY_KEY],
                  });
                  navigate(`/user/hr/documents/${document.id}/edit`);
                }}
              >
                {document.documentName}
              </Button>

              <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
                Test date: {document.documentDate}
              </Text>
              <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
                Upload date: {document.createdAt}
              </Text>
              <Flex direction="row" gap={1} style={{ marginLeft: "10px" }}>
                <Button
                  size="small"
                  variation="link"
                  style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  onClick={() => handleOnDocumentDeleteClick(document.id)}
                >
                  <FiTrash />
                </Button>
                <Button
                  size="small"
                  variation="link"
                  style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  onClick={() => {
                    navigate(`/user/hr/documents/${document.id}/edit`);
                  }}
                >
                  <RiPencilFill />
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Card>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          style={{ marginTop: "0px" }}
        ></Divider>
      </>
    );
  });
}
